import { render, staticRenderFns } from "./IsraelContactPersons.vue?vue&type=template&id=6a2857f4&scoped=true&"
import script from "./IsraelContactPersons.vue?vue&type=script&lang=js&"
export * from "./IsraelContactPersons.vue?vue&type=script&lang=js&"
import style0 from "./IsraelContactPersons.vue?vue&type=style&index=0&id=6a2857f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2857f4",
  null
  
)

export default component.exports